module.exports = __webpack_public_path__ + "img/audio.2e26ef54.svg";